import(/* webpackMode: "eager", webpackExports: ["PrintButton"] */ "/vercel/path0/web/components/article/print-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
